
// https://kryzen.com/wp-content/uploads/2022/02/18.png
// https://kryzen.com/wp-content/uploads/2024/02/1.jpg
// https://kryzen.com/wp-content/uploads/2024/02/22.jpg
// https://kryzen.com/wp-content/uploads/2024/02/33.jpg
// https://kryzen.com/wp-content/uploads/2024/02/7.jpg
// https://kryzen.com/wp-content/uploads/2024/02/25.jpg
// https://kryzen.com/wp-content/uploads/2024/02/36.jpg
// https://kryzen.com/wp-content/uploads/2024/02/5.jpg
// https://kryzen.com/wp-content/uploads/2024/02/27.jpg
// https://kryzen.com/wp-content/uploads/2024/02/17.jpg
// https://kryzen.com/wp-content/uploads/2024/02/14.jpg
// https://kryzen.com/wp-content/uploads/2024/02/13.
// https://kryzen.com/wp-content/uploads/2024/02/21.jpg
// https://kryzen.com/wp-content/uploads/2024/02/19.jpg
// https://kryzen.com/wp-content/uploads/2024/02/29.jpg
// https://kryzen.com/wp-content/uploads/2024/02/37.jpg
// https://kryzen.com/wp-content/uploads/2024/02/39.jpg
// https://kryzen.com/wp-content/uploads/2024/02/3.jpg
// https://kryzen.com/wp-content/uploads/2024/02/4.jpg
// https://kryzen.com/wp-content/uploads/2024/02/38.jpg
// https://kryzen.com/wp-content/uploads/2024/02/6.jpg
// https://kryzen.com/wp-content/uploads/2024/02/10.jpg
// https://kryzen.com/wp-content/uploads/2024/02/30.jpg
// https://kryzen.com/wp-content/uploads/2024/02/34.jpg
// https://kryzen.com/wp-content/uploads/2024/02/2.jpg
// https://kryzen.com/wp-content/uploads/2024/02/16.jpg
// https://kryzen.com/wp-content/uploads/2024/02/11.jpg
// https://kryzen.com/wp-content/uploads/2024/02/11.jpg
// https://kryzen.com/wp-content/uploads/2024/02/31.jpg
// https://kryzen.com/wp-content/uploads/2024/02/41.jpg
// https://kryzen.com/wp-content/uploads/2024/02/26.jpg
// https://kryzen.com/wp-content/uploads/2024/02/35.jpg
// https://kryzen.com/wp-content/uploads/2024/02/28.jpg
// https://kryzen.com/wp-content/uploads/2024/02/40.jpg
// https://kryzen.com/wp-content/uploads/2024/02/23.jpg
// https://kryzen.com/wp-content/uploads/2024/02/12.jpg
// https://kryzen.com/wp-content/uploads/2024/02/24.jpg
// https://kryzen.com/wp-content/uploads/2024/02/8.jpg
// https://kryzen.com/wp-content/uploads/2024/02/32.jpg
// https://kryzen.com/wp-content/uploads/2024/02/15.jpg
// https://kryzen.com/wp-content/uploads/2024/02/20.jpg
// https://kryzen.com/wp-content/uploads/2024/02/18.jpg
// https://kryzen.com/wp-content/uploads/2024/02/9.jpg
// https://i.ytimg.com/vi/_F3NaMPl3kM/maxresdefault.jpg?sqp=-oaymwEmCIAKENAF8quKqQMa8AEB-AH-CYAC0AWKAgwIABABGHIgTig0MA8=&rs=AOn4CLAeoTR7INalCVv6Mtffm-BnHA8jzQ
// https://kryzen.com/wp-content/uploads/2024/02/36-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/16-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/33-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/17-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/27-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/22-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/31-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/41-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/11-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/5-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/34-570x570.jpg
// https://kryzen.com/wp-content/uploads/2024/02/6-570x570.

import { useEffect } from "react";
import NewsletterSection from "../Components/Landing/newsletter";
import Footer from "../Components/Footer/footer";

export default function GalleryPage() {
  const images = [
    "https://kryzen.com/wp-content/uploads/2022/02/18.png",
    "https://kryzen.com/wp-content/uploads/2024/02/1.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/22.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/33.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/7.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/25.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/36.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/5.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/27.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/17.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/14.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/13.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/21.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/19.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/29.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/37.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/39.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/3.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/4.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/38.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/6.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/10.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/30.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/34.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/2.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/16.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/11.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/31.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/41.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/26.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/35.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/28.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/40.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/23.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/12.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/24.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/8.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/32.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/15.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/20.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/18.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/9.jpg",
    "https://i.ytimg.com/vi/_F3NaMPl3kM/maxresdefault.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/36-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/16-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/33-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/17-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/27-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/22-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/31-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/41-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/11-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/5-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/34-570x570.jpg",
    "https://kryzen.com/wp-content/uploads/2024/02/6-570x570.jpg",
  ];

  useEffect(() => {
    const reveal = () => {
      document.querySelectorAll(".reveal").forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 50) {
          el.classList.add("active");
        }
      });
    };
    window.addEventListener("scroll", reveal);
    reveal();
    return () => window.removeEventListener("scroll", reveal);
  }, []);

  return (
<>

<div className="bg-light py-5">
      <style>
        {`
        .gallery-img {
          width: 100%;
          height: 260px;
          object-fit: cover;
          border-radius: 10px;
          transition: transform 0.3s ease;
        }
        .gallery-img:hover {
          transform: scale(1.05);
        }
        .gallery-card {
          overflow: hidden;
        }
      `}
      </style>

      <div className="container-xl">
        <h2 className="text-center fw-bold display-5 mb-4 reveal">
          Photo Gallery
        </h2>

        <p className="text-center text-secondary mb-5 fs-5 reveal delay-1">
          Explore some of our best hydroponic farms, installations, events,
          trainings, and behind-the-scenes moments from Kryzen Biotech.
        </p>

        <div className="row g-4">
          {images.map((img, i) => (
            <div className="col-6 col-md-4 col-lg-3 reveal delay-1" key={i}>
              <div className="gallery-card shadow-sm">
                <img src={img} alt={`gallery-${i}`} className="gallery-img" />
              </div>
            </div>
          ))}
        </div>

        <NewsletterSection />

      </div>
    </div>
          <Footer />
</>

  );
}
